module.exports = __webpack_public_path__ + "img/cross.ebf2f3f4.svg";